<template>
  <div class="f-cartaHeaderAccordion">
    <h2 class="title-container">{{activeLanguage.theCarta}}</h2>
    <vue-accordion :items="items" :styles="styles"></vue-accordion>
    <read-carta-modal ref="readCartaModalExt"></read-carta-modal>
    <share-campaign-modal ref="shareCampaignModalExt"></share-campaign-modal>
  </div>
</template>

<script>
  import SignPetitionPage from '../../signPetitionPageComponents/SignPetitionPage'
  import ShareCampaignModal from './ShareCampaignModal'
  import ReadCartaModal from './ReadCartaModal'

  import Vue from 'vue'
  import {vueAccordion} from 'vue-accordion'

  Vue.component('vue-accordion', vueAccordion)

  export default {
    name: 'CartaHeaderAccordion',
    components: {ReadCartaModal, ShareCampaignModal},
    data () {
      return {
        items: null,
        styles: {
          // this will be bound to the style attribute of all `div`s inside the accordion
          div: {
            height: '300px'
          },
          // this will be bound to the style attribute of all `ul`s inside the accordion
          ul: {},
          // this will be bound to the style attribute of all `li`s inside the accordion
          li: {
            cursor: 'pointer',
            backgroundSize: 'cover'
          },
          // this will be bound to the style attribute of all `a`s inside the accordion
          a: {},
          // this will be bound to the style attribute of all `h2`s inside the accordion
          h2: {
            marginTop: '100px',
            opacity: 1,
            fontWeight: 'bold',
            fontSize: '2em',
            marginBottom: '0',
            paddingBottom: '1%',
            color: 'white'
          },
          // this will be bound to the style attribute of all `p`s inside the accordion
          p: {
            opacity: 1,
            fontSize: '1.4em',
            paddingBottom: '2%',
            fontWeight: 'bold',
            color: 'white'
          }
        }
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      }
    },
    methods: {
      loadSignPetition () {
        this.$store.commit('setCurrentView', SignPetitionPage)
        this.$router.push('/sign-petition')
      },
      loadShareCampaignModal () {
        this.$refs.shareCampaignModalExt.showModal()
      },
      loadReadCartaModal () {
        this.$refs.readCartaModalExt.showModal()
      }
    },
    mounted () {
      this.items = [
        {
          title: this.activeLanguage.read,
          text: this.activeLanguage.theCarta,
          url: '#',
          image: '../../../static/carta/read.jpg'
        },
        {
          title: this.activeLanguage.sign,
          text: this.activeLanguage.thePetition,
          url: '#',
          image: '../../../static/carta/sign.jpg'
        },
        {
          title: this.activeLanguage.share,
          text: this.activeLanguage.ourCampaign,
          url: '#',
          image: '../../../static/carta/share.jpg'
        }
      ]
      let self = this
      setTimeout(function () {
        let accordion = document.getElementsByClassName('vue-accordion')[0].getElementsByTagName('LI')
        accordion[0].getElementsByTagName('A')[0].removeAttribute('href')
        accordion[0].onclick = function () {
          self.loadReadCartaModal()
        }

        accordion[1].getElementsByTagName('A')[0].removeAttribute('href')
        accordion[1].onclick = function () {
          self.loadSignPetition()
        }

        accordion[2].getElementsByTagName('A')[0].removeAttribute('href')
        accordion[2].onclick = function () {
          self.loadShareCampaignModal()
        }
      }, 500)
    }
  }
</script>

<style scoped>

  .f-cartaHeaderAccordion{
    padding-top: 3%;
  }
  .vue-accordion {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/cartaAlpFoodWay/CartaHeaderAccordion.vue